import React, { useState, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const TextEditorQuill = () => {
  const quillRef = useRef();
  const [value, setValue] = useState('');
  const [isUploading, setIsUploading] = useState(false);

  const imageHandler = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (!file) return;

      setIsUploading(true);
      const formData = new FormData();
      formData.append('image', file);

      try {
        const res = await fetch('/api/upload-image', {
          method: 'POST',
          body: formData,
        });

        const data = await res.json();
        const imageUrl = data.imageUrl;

        const editor = quillRef.current.editor;
        const range = editor.getSelection(true);
        editor.insertEmbed(range.index, 'image', imageUrl);
        editor.setSelection(range.index + 1);
      } catch (err) {
        console.error('Upload failed:', err);
        alert('Image upload failed');
      } finally {
        setIsUploading(false);
      }
    };
  };

  const modules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image'],
        ['clean'],
      ],
      handlers: {
        image: imageHandler,
      },
    },
  };

  const formats = [
    'bold', 'italic', 'underline',
    'list', 'bullet',
    'link', 'image',
  ];

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Editor</h2>
      {isUploading && <p style={{ color: 'blue' }}>Uploading image...</p>}

      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        // onChange={setValue}
        modules={modules}
        formats={formats}
        style={{ height: '300px' }}
        placeholder="Start writing..."
      />

      <button
        onClick={() => console.log(value)}
        style={{
          marginTop: '1rem',
          padding: '10px 20px',
          backgroundColor: '#4caf50',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
        }}
      >
        Save Content
      </button>
    </div>
  );
};

export default TextEditorQuill;
